export default __webpack_public_path__ + "number-bg.svg";